import React, { useState } from 'react'
import pic from '../assets/img/favicon.ico'
 import pic1 from '../assets/img/1.png'
 import '../css/style.css'
import { Link } from 'react-router-dom'
export default function Header() {
  const [mod,setMode]=useState(1)
  let count=1;
  const info=(e)=>{
    // console.log(e)
    console.log(count);
    
    if(count%2){
        document.getElementById('ul').style.display='block'
        document.getElementById('ul1').style.display='block'
    }else{
        document.getElementById('ul').style.display='none'
        document.getElementById('ul1').style.display='none'
       
    }
    count++
  }
  const sideBar=(e)=>{
          console.log(e);
          document.getElementById('ul3').classList.add('slideRigth')
          document.getElementById('ul3').classList.remove('slideToRigth')
  } 
  const exit=(e)=>{
    document.getElementById('ul3').classList.add('slideToRigth')
    document.getElementById('ul3').classList.remove('slideRigth')
  }
  return (
   <>
      <section className='w-full overflow-x-hidden  hidden xl:flex  h-[220px] '>
            <header className='w-full h-[120px]  flex flex-wrap justify-center items-center  *:h-1/2 *:w-full'>
                    
                    <div className='border-[#323F57] border-b-2 h-full'>
                      <div className='flex bg-[rgb(40,49,68)] flex-wrap justify-center items-center w-full h-full'>
                          <div className='w-[80%] h-full flex justify-between items-center'>
                              <div className='h-full'>
                                    <figure className='flex items-center h-full *:px-1 '>
                                            <img className='object-contain h-10  ' src={pic} alt='' />
                                            <figcaption className='text-3xl flex items-center  h-full text-[#D8DEEA] font-semibold'>فرست</figcaption>
                                    </figure>
                              </div>
                              <div className='flex flex-row-reverse items-center gap-4 *:px-3  *:w-1/5 h-12'>
                                  <div className='w-full h-full flex items-center justify-center  '>
                                        <figure className='relative h-full w-full '>
                                              <img onClick={(e)=>{info(e)}} className='object-fill cursor-pointer rounded-[100%] w-full h-full' src={pic1} alt='pic1' />
                                              <figcaption className='w-1 h-1 bg-[#39DA8A] border-black border-2 p-1 absolute right-0 bottom-0 rounded-full'></figcaption>
                                            
                                        </figure>
                                        <ul id='ul1' className='h-[380px] w-[220px] text-[#A1B0C7] hidden  bg-[#283144] left-[9%] top-[58px] fixed gap-4  z-40'>
                                             <li className='px-4 hover:bg-[#a1b0cb27] py-2 flex *:w-1/2 border-b-2 border-[#323F57]'>
                                                <div className='flex justify-between items-center relative '>
                                                        <img  className='object-fill cursor-pointer rounded-[100%] w-10 h-10' src={pic1} alt='pic1' />
                                                        <figcaption className='w-1 h-1 bg-[#39DA8A] border-black border-2 p-1 absolute right-0 bottom-0 rounded-full'></figcaption>
                                                </div>
                                                <div className='flex flex-wrap *:w-full justify-center items-center'>
                                                        <h2 className='font-medium'>جان اسنو</h2>
                                                        <span>مدیر</span>
                                                </div>
                                              </li>
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                 
                                                  <i class="ri-user-fill text-xl font-medium"></i><span>پروفایل من</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-settings-2-line text-xl font-medium"></i><span> تنظیمات</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2 border-b-2 border-[#323F57]'>
                                                  <i class="ri-bank-card-line text-xl font-medium"></i><span> صورت حساب</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-customer-service-line text-xl font-medium"></i><span> پشتیبانی</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-question-line text-xl font-medium"></i><span> سوالات متدوال</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2 border-b-2 border-[#323F57]'>
                                                 
                                                  <i class="ri-money-dollar-circle-line text-xl font-medium"></i><span> قیمت گذاری </span>  
                                                  </li>
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2 cursor-pointer'>
                                                        <Link className='flex items-center *:px-1' to='/login'>
                                                        <i class="ri-logout-circle-line  text-xl font-medium"></i>
                                                        <span> خروج </span>
                                                        </Link>  
                                                  </li>            
                                        </ul>
                                  </div>
                                  <div className='flex items-center justify-center '>
                                        <span className='flex w-full h-full   items-center justify-center relative'>
                                          <i class="ri-notification-2-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                          <i className='flex justify-center items-center w-4 h-4 absolute top-0 left-1 p-1 rounded-full text-xs text-white bg-[#FF5B5C]'>0</i>
                                        </span>
                                  </div>
                                  <div className='flex items-center justify-center'>
                                       <i class="ri-function-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                       <i class="ri-function-line hidden hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                  </div>
                                  <div className='flex items-center justify-center'>
                                  <i class="ri-sun-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                  </div>
                                  <div className='flex items-center justify-center'>
                                  <i class="ri-search-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                  </div>
                                  

                              </div>
                          </div>
                      </div>
                    </div>
                    <nav className='bg-[#283144] flex justify-center items-center '>
                          <div className='w-full h-full  flex justify-center items-center'>
                                <ul className='w-[80%] text-[#a1b0cb] h-full  flex justify-start  items-center font-medium 2xl:gap-10  text-md *:mx-2  *:w-1/6  *:cursor-pointer *:h-10'>
                                      <li className='flex group relative  items-center  rounded-[0.3125rem] justify-between bg-[#5A8DEE] text-white   px-1 gap-2'>
                                          <div className='*:px-1 '>
                                              <i class="ri-home-7-line"></i>
                                              <i>داشبوردها</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                          {/*click  */}
                                          <ul className='w-[220px] text-[#a1b0cb] rounded-[0.3125rem] group-hover:block h-[100px] hidden absolute z-[999] top-10 *:py-3 *:px-2 -right-4 bg-[#283144] '>
                                                  <li className=' *:px-[2px] hover:bg-[#2D374B]'>
                                                  <i class="ri-pie-chart-2-fill"></i>
                                                  <span> تجزیه و تحلیل </span>
                                                  
                                                  </li>
                                                  <li className=' *:px-[2px] hover:bg-[#2D374B]'>
                                                  <i class="ri-trademark-line"></i>
                                                  <span>  تجارت الکترونیک </span>
                                                  
                                                  </li>
                                          </ul>
                                      </li>
                                      <li className='flex items-center  hover:bg-[#2D374B]  rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                              <i class="ri-layout-2-line"></i>
                                              <i>طرح ها</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                              <i class="ri-window-line"></i>
                                              <i>برنامه ها</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-pages-line"></i>
                                              <i> صفحات</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-code-box-line"></i>
                                              <i> اجزا</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-keyboard-line"></i>
                                              <i>فرم ها</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      {/* <li className='hidden xl:flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-table-line"></i>
                                              <i>جدول ها</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      <li className='hidden xl:flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1 '>
                                          <i class="ri-map-pin-line"></i>
                                              <i> نقشه  ها</i> 
                                          </div>
                                    
                                          <div className=''>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>
                                      <li className=' hidden xl:flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                              <i class="ri-window-line"></i>
                                              <i> متفرقه</i>
                                          </div>
                                    
                                          <div>
                                            <i class="ri-arrow-drop-down-line"></i>
                                          </div>
                                      </li>  */}
                                </ul>
                          </div>
                    </nav>
            </header>
      </section>
      {/*header mobile  */}
      <section className='w-full relative overflow-x-hidden flex xl:hidden  h-full '>
              <div className=' h-[70px] w-full'>
              <div className='w-full h-full flex justify-between items-center'>
                              <div className='h-full flex items-center px-2'>
                                   <button onClick={(e)=>{sideBar(e)}}  className=''><i class="ri-menu-line text-3xl text-[#A1B0C7]"></i></button>
                              </div>
                              <div className='flex flex-row-reverse items-center gap-1 *:px-1  *:w-1/5 h-12'>
                                  <div className='w-full h-full flex items-center justify-center  '>
                                        <figure className='relative h-full w-full '>
                                              <img onClick={(e)=>{info(e)}} className='object-fill cursor-pointer rounded-[100%] w-full h-full' src={pic1} alt='pic1' />
                                              <figcaption className='w-1 h-1 bg-[#39DA8A] border-black border-2 p-1 absolute right-0 bottom-0 rounded-full'></figcaption>
                                            
                                        </figure>
                                        <ul id='ul' className='h-[380px] w-[80%] text-[#A1B0C7] hidden  bg-[#283144] left-[9%] top-[58px] fixed gap-4  z-40'>
                                             <li className='px-4 hover:bg-[#a1b0cb27] py-2 flex *:w-1/2 border-b-2 border-[#323F57]'>
                                                <div className='flex justify-between items-center relative '>
                                                        <img  className='object-fill cursor-pointer rounded-[100%] w-10 h-10' src={pic1} alt='pic1' />
                                                        <figcaption className='w-1 h-1 bg-[#39DA8A] border-black border-2 p-1 absolute right-0 bottom-0 rounded-full'></figcaption>
                                                </div>
                                                <div className='flex flex-wrap *:w-full justify-center items-center'>
                                                        <h2 className='font-medium'>جان اسنو</h2>
                                                        <span>مدیر</span>
                                                </div>
                                              </li>
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                 
                                                  <i class="ri-user-fill text-xl font-medium"></i><span>پروفایل من</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-settings-2-line text-xl font-medium"></i><span> تنظیمات</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2 border-b-2 border-[#323F57]'>
                                                  <i class="ri-bank-card-line text-xl font-medium"></i><span> صورت حساب</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-customer-service-line text-xl font-medium"></i><span> پشتیبانی</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-question-line text-xl font-medium"></i><span> سوالات متدوال</span>  
                                                  </li>           
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2 border-b-2 border-[#323F57]'>
                                                 
                                                  <i class="ri-money-dollar-circle-line text-xl font-medium"></i><span> قیمت گذاری </span>  
                                                  </li>
                                                  <li className='hover:bg-[#a1b0cb27] px-4 py-2 flex gap-2'>
                                                  <i class="ri-logout-circle-line text-xl font-medium"></i><span> خروج </span>  
                                                  </li>            
                                        </ul>
                                  </div>
                                  <div className='flex items-center justify-center '>
                                        <span className='flex w-full h-full   items-center justify-center relative'>
                                          <i class="ri-notification-2-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                          <i className='flex justify-center items-center w-4 h-4 absolute top-0 left-1 p-1 rounded-full text-xs text-white bg-[#FF5B5C]'>0</i>
                                        </span>
                                  </div>
                                  <div className='flex items-center justify-center'>
                                       <i class="ri-function-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                       <i class="ri-function-line hidden hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                  </div>
                                  <div className='flex items-center justify-center'>
                                  <i class="ri-sun-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                  </div>
                                  <div className='flex items-center justify-center'>
                                  <i class="ri-search-line hover:text-[#D8DEEA] text-[#637ba9] text-3xl"></i>
                                  </div>
                                  

                              </div>
                          </div>
              </div>
      </section>
      <ul id='ul3' className='  *:px-2 *:py-2 w-1/2 md:w-1/4 translate-x-[100%] text-[#a1b0cb] font-semibold h-full bg-[#1C222F]  absolute z-50 right-0 top-0 *:w-full *:my-4  '>
            <li className='flex justify-between items-center'>
              <figure className='flex items-center *:px-1'>
                <img className='object-contain' src={pic} />
                <figcaption className='text-2xl text-[#FFFFFF] font-md'>فرست</figcaption>
              </figure>
              <div className=''>
                 <i onClick={(e)=>exit(e)} class="ri-close-line  font-bold text-[#4e77d1]"></i>
              </div>
            </li>
            {/*  */}
            <li className='flex items-center  hover:bg-[#2D374B]  rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                              <i class="ri-layout-2-line"></i>
                                              <i>طرح ها</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                              <i class="ri-window-line"></i>
                                              <i>برنامه ها</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-pages-line"></i>
                                              <i> صفحات</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-code-box-line"></i>
                                              <i> اجزا</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-keyboard-line"></i>
                                              <i>فرم ها</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                          <i class="ri-table-line"></i>
                                              <i>جدول ها</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1 '>
                                          <i class="ri-map-pin-line"></i>
                                              <i> نقشه  ها</i> 
                                          </div>
                                    
                                          <div className=''>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li>
                                      <li className='flex items-center hover:bg-[#2D374B] rounded-[0.3125rem] justify-between  px-1 gap-2'>
                                          <div className='*:px-1'>
                                              <i class="ri-window-line"></i>
                                              <i> متفرقه</i>
                                          </div>
                                    
                                          <div>
                                          <i class="ri-arrow-drop-left-line"></i>
                                          </div>
                                      </li> 
      </ul>
   </>
  )
}
